import { render } from "./ClanRanking.vue?vue&type=template&id=8d87cbb0&scoped=true"
import script from "./ClanRanking.vue?vue&type=script&lang=js"
export * from "./ClanRanking.vue?vue&type=script&lang=js"

import "./ClanRanking.vue?vue&type=style&index=0&id=8d87cbb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d87cbb0"]])

export default __exports__